import { StockProduct } from "../../models/products/stock-product";

export interface ProductsState {
    products: StockProduct[];
}

export const initialState: ProductsState = {
    products: []
}
